import { ApplicationConfig, LOCALE_ID } from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import * as solidIcons from '@fortawesome/free-solid-svg-icons';

import { initializeApp, provideFirebaseApp, getApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getStorage, provideStorage } from '@angular/fire/storage';

import { provideFunctions, getFunctions } from '@angular/fire/functions';

import { provideAnimations } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { provideHttpClient } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { AutoResizeTextDirective } from './directives/auto-resize-text.directive';
import { ConfirmationService } from 'primeng/api';
import { ToastService } from './services/toast.service';
import { env } from './env.generated';
import { firebaseConfig } from './firebase.config';

import { routes } from './app.routes';
import { SongService } from './services/song.service';
import { ProjectionService } from './services/projection.service';
import { importProvidersFrom } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideEchartsCore } from 'ngx-echarts';
import * as echarts from 'echarts/core';
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
} from 'echarts/components';
import { PieChart, BarChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';

// Registrar componentes / charts / renderer que va a usar ECharts
echarts.use([
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  PieChart,
  BarChart,
  CanvasRenderer
]);

import AOS from 'aos';
AOS.init();
export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideFirebaseApp(() => initializeApp(firebaseConfig)),
    provideAuth(() => getAuth()),
    provideFirestore(() => {
      const app = getApp();
      if ((env.NG_APP_MISSION_ID as string) === 'italia') {
        return getFirestore(app, 'dbprincipal');
      }
      return getFirestore(app);
    }),
    provideStorage(() => getStorage()),
    provideFunctions(() => getFunctions(getApp(), env.NG_APP_FUNCTIONS_REGION)),
    provideRouter(routes, withViewTransitions()),
    provideEchartsCore({ echarts }),
    SongService, // Provide SongService
    ProjectionService, // Provide ProjectionService
    AutoResizeTextDirective,
    provideHttpClient(),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'es',
      })
    ),
    ...provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
    ConfirmationService,
    ToastService,
    { provide: LOCALE_ID, useValue: 'es' },
    MessageService,
    {
      provide: FaIconLibrary,
      useFactory: () => {
        const library = new FaIconLibrary();
        const iconDefinitions = Object.values(solidIcons).filter(
          (value) => typeof value === 'object' && value !== null && 'prefix' in value
        );
        library.addIcons(...(iconDefinitions as any));
        return library;
      },
    },
    provideAnimations(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          prefix: 'p',
          darkModeSelector: false,
          cssLayer: false
        }
      }
    })
  ],
};
